<script>
import { useRoute } from "#imports";
import { inView } from "motion";
import { computed, defineComponent, onMounted, ref } from "vue";
export default defineComponent({
  props: {
    slice: Object,
    ssrOnly: Boolean,
    clientOnly: Boolean,
    whenIdle: Boolean,
    load: Boolean,
    whenVisible: [Boolean, Object],
    didHydrate: Function,
    promise: Object,
    on: [Array, String]
  },
  setup(props) {
    function isBrowser() {
      return typeof window === "object";
    }
    const route = useRoute();
    const isEditorIframe = computed(() => route.query["voix-sync"]);
    const sliceInView = ref(false);
    const inViewRefRoot = ref(null);
    onMounted(() => {
      if (props.whenVisible && inViewRefRoot.value) {
        inView(inViewRefRoot.value, () => {
          sliceInView.value = true;
        });
      }
    });
    return { props, isBrowser, isEditorIframe, inViewRefRoot, sliceInView };
  }
});
</script>

<template>
  <template v-if="whenIdle">
    <DelayHydration>
      <slot />
    </DelayHydration>
  </template>
  <template v-else-if="props.whenVisible">
    <div ref="inViewRefRoot">
      <slot v-if="sliceInView" />
    </div>
  </template>
  <template v-else>
    <template v-if="props.clientOnly && isBrowser()">
      <slot />
    </template>
    <template v-else>
      <slot />
    </template>
  </template>
</template>
